import { Router } from "@angular/router";
import { RolesSharedService } from "./../../services/roles-shared.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FilterUtilService } from "@app/shared/services/filter-util.service";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { TechBuyerService } from "@app/feature/main/tech-buyer/shared/services/tech-buyer.service";
import swal from "sweetalert2";
import { SortValues } from "@app/shared/constants/app.constants";
import { DataService } from "@app/feature/main/roles-shared/services/data.service";
import { Paginator } from "primeng/paginator";
import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import { CompanyDetailsComponent } from './../../../tech-buyer/company-details/company-details.component';

declare var $: any;
import * as _ from 'lodash';
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
@Component({
  selector: "app-trending-research",
  templateUrl: "./trending-research.component.html",
  styleUrls: ["./trending-research.component.css"]
})
export class TrendingResearchComponent implements OnInit {
  @ViewChild('paginatorId') paginator = new Paginator();
  @ViewChild(CompanyDetailsComponent) companyDetails: CompanyDetailsComponent;
  accessToken;
  userId;
  userDetailsObject;
  trendingResearchData = [];
  userRole;
  hasCompanyDetails = false;
  loggedInStatus;
  techDomainListselected = null;
  techDomainListData: object;
  sortListData;

  // search
  searchKeyword = "";
  selectedDomain = "";
  searchString = "";
  sortSelectedindex = null;
  techDomainData;

  // Filter
  totalRecords = 0;
  dataLimit = 9;
  skipValue = 0;
  constructor(
    public rolesSharedService: RolesSharedService,
    public router: Router,
    private breadcrumService:BreadcrumService,

    public filterUtilService: FilterUtilService,
    public authenticationService: AuthenticationService,
    private techBuyerService: TechBuyerService,
    private dataService: DataService,
    private nickNameModalService: NickNameModalService,
    private commentModalService: CommentModalService
  ) {
   // window.scroll(0, 0);
  }
  ngOnInit() {
    this.isLoggedIn();
    this.userDetails();
    this.getDomainList();
    this.techDomainListselected = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : null;

    this.trendingResearchDataObject();
    this.sortListData = SortValues.list;

  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
    if (this.userRole === 'tech-buyer') {
      this.checkDetails();
    }
  }

  getDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe(data => {

      this.techDomainListData = data;
    });
  }

  onScrollDown() {
    this.skipValue = this.skipValue + 9;
    if (this.paginator) {
      this.paginator.first = 0;
    }
    this.trendingResearchDataObject();
  }

  getAllResearchDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        {
          research: [
            {
              survey: {
                responses: "users"
              }
            },
            "domain"
          ]
        },
        {
          likes: "user"
        },
        {
          comments: "user"
        },
        {
          ratings: "user"
        }
      ]
    });
    filter.limit = this.dataLimit;
    filter.skip = this.skipValue;
    filter.search = this.searchString;
    filter.sort = this.sortSelectedindex ? JSON.stringify(this.sortSelectedindex) : JSON.stringify({ "ordering": "DESC" });
    if (this.techDomainListselected) {
      filter.where = JSON.stringify({
        techDomainId: this.techDomainListselected
      });
    }

    return filter;
  }

  trendingResearchDataObject() {
    this.rolesSharedService
      .getTrendingResearches(this.getAllResearchDataFilter())
      .subscribe(
        (response: any) => {
          this.trendingResearchData = _.uniqWith([...this.trendingResearchData, ...response.data], _.isEqual);
          this.totalRecords = response.totalCount;
        },
        error => {
        }
      );
  }

  isAccessible(trendingDataObj) {
    // research document click
    if (this.loggedInStatus && this.userRole === "tech-buyer") {
      if (!this.hasCompanyDetails) {
        this.showModal();
      } else {
        this.snapshotPageNavigation(trendingDataObj);
      }
    } else if (this.userRole === "tech-vendor") {
      this.snapshotPageNavigation(trendingDataObj);
    } else {
      this.snapshotPageNavigation(trendingDataObj);
    }
  }

  openCommentModal(data) {
    this.userDetailsObject = JSON.parse(
      window.sessionStorage.getItem("userDetails")
    );
    if (this.loggedInStatus && this.userDetailsObject.nickName) {
      this.commentModalService.modalStatus(true, data);
    } else {
      this.nickNameModalService.openNickNameModal();
    }
  }

  refresh(evt: any) {
    this.getTechBuyerDetails();
    $("#company-details").modal("hide");
  }

  getTechBuyerDetails() {
    this.techBuyerService
      .getTechBuyerDetails(this.userId)
      .subscribe((response: any) => {
        if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
          const modifiedUserDetails = Object.assign(
            JSON.parse(window.sessionStorage.getItem("userDetails")),
            { organization: response.organization },
            { techBuyerOrganization: response.techbuyerOrganization }
          );
          this.hasCompanyDetails = true;
          window.sessionStorage.setItem(
            "userDetails",
            JSON.stringify(modifiedUserDetails)
          );
          if (window.localStorage.getItem("rememberMeStatus")) {
            if (window.localStorage.getItem("rememberMeStatus") === "true") {
  
              window.localStorage.setItem(
                "userDetails",
                JSON.stringify(modifiedUserDetails)
              );
            }
          }
          this.checkDetails();
        }
      });
  }

  likeClick(postData, index) {
    // like button click
    if (this.loggedInStatus) {

      if (this.userDetailsObject.nickName) {
        const dataBody = {
          postId: postData.id,
          postType: "trending_research",
          userId: this.userId
        };
        this.rolesSharedService.addLike(dataBody).subscribe(likeResponse => {
          if (likeResponse["liked"]) {
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
            this.rolesSharedService.logLikeInMixpanel(dataBody.postType, postData.title);
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes != 0) {
              postData.likes -= 1;
            }
          }
        })
      } else {

        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        })
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  checkDetails() {
    if (
      !JSON.parse(window.sessionStorage.getItem("userDetails")).organization
    ) {
      this.hasCompanyDetails = false;
    } else {
      this.hasCompanyDetails = true;
    }
  }

  showModal() {
    $("#company-details").modal("show");
    this.companyDetails.initializeModal();
  }

  applyFilter() {
    this.dataLimit = 9;
    this.skipValue = 0;
    if (this.paginator) {
      this.paginator.first = 0;
    }
    this.trendingResearchData = [];
    this.trendingResearchDataObject();
  }

  paginate(event: any) {
    this.dataLimit = event.rows;
    this.skipValue = event.first;
    this.trendingResearchDataObject();
  }

  allResearchNavigation() {
    this.router.navigate([`${this.userRole}/research/all-research`]);
  }

  snapshotPageNavigation(trendingDataObj) {
    this.breadcrumService.setUrl('BC3Label',trendingDataObj.research.title);

    let researchDataModel = {
      id: trendingDataObj.research.id,
      title: trendingDataObj.research.title,
      participants: trendingDataObj.participants,
      ratings: trendingDataObj.ratings,
      createdAt: trendingDataObj.research.createdAt,
      synopsis: trendingDataObj.research.synopsis,
      isParticipated: trendingDataObj.isParticipated,
      surveyId: trendingDataObj.research.survey.id
    };
    this.dataService.researchDocumentDataService(researchDataModel);
    if (this.userRole === 'tech-vendor') {
      this.router.navigate([`${this.userRole}/market-data/${researchDataModel.id}`]);
    } else {
      this.router.navigate([`${this.userRole}/research-snapshot/${researchDataModel.id}`]);
    }
  }

  featureUnderConstructionNavigation() {
    this.router.navigate([`${this.userRole}/under-construction`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/trending-research/trending-research.component.ts